import React, { useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const TiltCard = ({ children, className = "", max = 8 }) => {
  const rxRaw = useMotionValue(0);
  const ryRaw = useMotionValue(0);
  const rotateX = useSpring(rxRaw, { stiffness: 200, damping: 18 });
  const rotateY = useSpring(ryRaw, { stiffness: 200, damping: 18 });
  const [hover, setHover] = useState(false);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    ryRaw.set((px - 0.5) * max * 2);
    rxRaw.set(-(py - 0.5) * max * 2);
  };
  const reset = () => { rxRaw.set(0); ryRaw.set(0); setHover(false); };

  // Touch: enable the gold glow on tap (no cursor-based tilt on mobile)
  const onTouchStart = () => setHover(true);
  const onTouchEnd = () => setTimeout(reset, 250);

  return (
    <div style={{ perspective: 1000 }} className={className}>
      <motion.div
        className="group h-full rounded-3xl"
        onMouseMove={onMove}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={reset}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        whileTap={{ scale: 0.985 }}
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        animate={{
          boxShadow: hover
            ? "0 26px 60px -22px rgba(178,164,117,0.55), 0 0 0 1px rgba(178,164,117,0.55)"
            : "0 12px 32px -22px rgba(0,0,0,0.7), 0 0 0 1px rgba(178,164,117,0.20)",
        }}
        transition={{ duration: 0.35 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default TiltCard;
